import { indexOrKey } from '../cloudquote-data-table';

export let buildYears = ({ columns, rows }) => {
	let i = columns.indexOf('Date'),
		years = {};

	rows.forEach( (row) => {
		let d = new Date(row[i]),
			year = d.getFullYear(),
			month = d.getMonth() + 1;

		if (years[year]) {
			if (years[year][month]) {
				years[year][month].push(row);
			}
			else {
				years[year][month] = [row];
			}
		}
		else {
			years[year] = { [month]: [row] };
		}
	});
	return years;
};

export let adjustTimerange = (start, end, interval, data) => {
	if (interval === '1D') {
		let day = data.rows[0],
			dayInMilliseconds = 8.64e+7,
			t = apiDate({
				start: day[0] - dayInMilliseconds,
				end: day[0]
			});

		start = t.start;
		end = t.end;

		data.rows = [day];
	}

	if (interval === 'MAX') {
		let day = data.rows.slice(-1)[0],
			t = apiDate({ start: day[0], end });

		start = t.start;
	}

	return { timerange: { start, end }, cacheData: data };
};

/**
 * Set the start date to a week ago.
 * @param {String} start    the start date "2016-10-14"
 * @returns {String}        returns a date "2016-10-07"
 */
export let setStart = (start) => {
	let newDay,
		daysInWeek = 7,
		ten = 10;

	start = start.split('-');
	newDay = start[2] - daysInWeek;
	start[2] = newDay < ten ? `0${newDay}` : newDay;

	return start.join('-');
};

export let apiDate = (timerange) => {
	timerange.end = new Date(timerange.end).toISOString().split('T')[0];
	timerange.start = new Date(timerange.start).toISOString().split('T')[0];

	return timerange;
};

export let sortData = ({ columns, rows }) => {
	let dateKey = !columns ? 'eventDate' : indexOrKey(columns, 'Date');
	rows = rows || [];
	rows = rows.sort( (a, b) => b[dateKey] > a[dateKey] ? 1 : -1 );
	return { columns, rows };
};

export let filterRows = (rows = [], start, end ) => rows.filter( (row, i) => row.eventDate >= start && row.eventDate <= end);
